export default "__VITE_ASSET__cd777501__"